import type { WmsShipmentInboundType } from 'schemas/shipment/inbound/detail';
import { InboundShipmentContentsTable } from './InboundShipmentContentsTable';

type InboundShipmentContentsTabProps = {
  data: WmsShipmentInboundType;
};

export function InboundShipmentContentsTab({ data }: InboundShipmentContentsTabProps) {
  return <InboundShipmentContentsTable data={data} />;
}
